import { httpClient } from "./client";
import type { UnifiedSearchParams, UnifiedSearchResponse, UnifiedSearchSection, UnifiedSearchSuggestion, UnifiedSearchSuggestionsResponse } from "../types/generated";

export type SearchResponse = UnifiedSearchResponse;
export type SearchSection = UnifiedSearchSection;
export type SearchHit = SearchSection["items"][number];
export type SearchSuggestion = UnifiedSearchSuggestion;
export type SearchSuggestionsResponse = UnifiedSearchSuggestionsResponse;
export type SearchVertical = SearchSection["category"];
export type SearchCategory = SearchResponse["category"];

export type SearchParams = UnifiedSearchParams;

export const searchApi = {
  search(params: SearchParams) {
    const query = new URLSearchParams();
    for (const [key, value] of Object.entries(params)) {
      if (value !== undefined && value !== null && value !== "") query.set(key, String(value));
    }
    return httpClient.get<SearchResponse>(`/search?${query}`);
  },
  suggestions(q: string, category: SearchCategory = "all", city?: string) {
    return httpClient.get<SearchSuggestionsResponse>(`/search/suggestions?${new URLSearchParams({ q, category, ...(city ? { city } : {}) })}`);
  },
};
